export default __webpack_public_path__ + "static/media/see-plans-icon.3e1cbbae.svg";